import { TableBody as MUITableBody } from "@material-ui/core";
import ExpandingTableRow from "./ExpandingTableRow";
import GroupedTableRow from "./GroupedTableRow";
import TableRow from "./TableRow";
import type {
  EditedRowProps,
  ExpandingRowDefinition,
  GroupedTableRowDefinition,
  TableProps,
  TableRowDefinition,
} from "./types";

const isGroupedRow = (
  row: TableRowDefinition | GroupedTableRowDefinition,
): row is GroupedTableRowDefinition => !!row.header;

const isExpandingRow = (
  row: TableRowDefinition | ExpandingRowDefinition,
): row is ExpandingRowDefinition => !!row.meta?.isExpanding;

const TableBody = (props: TableProps & EditedRowProps) => {
  const { rows } = props;
  return (
    <MUITableBody>
      {rows.map((row, index) => {
        if (isGroupedRow(row)) {
          return (
            <GroupedTableRow
              key={`row-${row.header.id}`}
              row={row}
              index={index}
              {...props}
            />
          );
        }

        if (isExpandingRow(row)) {
          return (
            <ExpandingTableRow
              key={`row-${row.id}`}
              row={row}
              index={index}
              {...props}
            />
          );
        }

        return (
          <TableRow key={`row-${row.id}`} row={row} index={index} {...props} />
        );
      })}
    </MUITableBody>
  );
};

export default TableBody;
